import React from 'react';
import PropTypes from 'prop-types';
import ToggleButtonSelection from '../toggle-button-selection';
import {Form as BsForm} from 'react-bootstrap';
import I18n from '../i18n';
import FormContext from '../../contexts/form-context';
import classnames from 'classnames';
import FieldChangedIndicator from '../field-changed-indicator';
import get from '../../utils/get';

export default function FormToggleButtonSelection(props) {
  const {name, groupProps, multiselect, buttonOptions, labelProps, ...rest} = props;
  const {values, initialValues, setFieldValue, errors, touched, handleBlur} = React.useContext(FormContext);

  const handleChange = values => {
    const fieldValue = multiselect ? values.map(value => value.value) : values.value;
    setFieldValue(name, fieldValue);
  };

  return (
    <BsForm.Group {...groupProps}>
      <BsForm.Label {...labelProps}>
        <I18n t={`property.${name}`} />
        <FieldChangedIndicator
          name={name}
          originalValue={get(initialValues, name)}
          value={get(values, name)}
          onRevert={setFieldValue}
        />
      </BsForm.Label>
      <ToggleButtonSelection
        name={name}
        value={get(values, name)}
        className={classnames(get(touched, name) && !!get(errors, name) ? 'is-invalid' : '')}
        multiselect={multiselect}
        buttonOptions={buttonOptions}
        onChange={handleChange}
        isInvalid={get(touched, name) && !!get(errors, name)}
        onBlur={handleBlur}
        {...rest}
      />
      <BsForm.Control.Feedback type="invalid">{get(errors, name)}</BsForm.Control.Feedback>
    </BsForm.Group>
  );
}

FormToggleButtonSelection.defaultProps = {
  multiselect: true,
  groupProps: {},
};

FormToggleButtonSelection.propTypes = {
  /** Name for the form control. */
  name: PropTypes.string.isRequired,
  /** Additional props to pass to the FormGroup */
  groupProps: PropTypes.object,
  /** Additional props to pass to the FormLabel */
  labelProps: PropTypes.object,
  /** A bool value to for multiselect or singleselect. */
  multiselect: PropTypes.bool,
  /** An object passed to the component for button group. */
  buttonOptions: PropTypes.array.isRequired,
};
